<template>
  <v-container fluid>
    <v-card flat>
      <v-toolbar>
        <v-icon color="orange">print</v-icon>
        <v-toolbar-title class="font-weight-light">
          <v-row>
            <v-col>
              <div>&nbsp;Impresión de Comprobantes</div>
            </v-col>
          </v-row>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="hide(false)"><v-icon>close</v-icon></v-btn>
      </v-toolbar>

      <v-container fluid>
        <v-alert
          v-if="apiSerialPrintConfigurada && !apiSerialPrintValidada"
          type="info"
        >
          Atención, no se pudo verificar el funcionamiento de la Api de
          Impresión.
        </v-alert>
      </v-container>

      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col cols="3" class="caption"> Caja </v-col>
            <v-col>
              {{ caja.descripcion }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" class="caption"> Transaccion Id </v-col>
            <v-col>
              {{ transaccionId }}
            </v-col>
          </v-row>

          <v-data-table
            :headers="headers"
            :items="listComprobantes"
            :loading="loading"
            :server-items-length="totalItems"
            :rows-per-page="pagination.rowsPerPage"
            :options.sync="pagination"
            dense
          >
            <template v-slot:no-data>
              <v-alert :value="true" icon="warning">
                No hay movimientos en el día
              </v-alert>
            </template>

            <template v-slot:item="{ item }">
              <tr>
                <td class="text-xs-left caption">{{ item.tipo }}</td>
                <td class="text-xs-left caption">{{ item.info }}</td>
                <td class="text-xs-left caption">
                  {{ item.importe | currency }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          color="blue darken-1"
          text
          @click.stop="hide(false)"
          :disabled="loading"
          >Cerrar</v-btn
        >
        <v-spacer></v-spacer>

        <v-btn
          color="blue darken-1"
          text
          @click.stop="imprimir()"
          :disabled="loading"
          >Imprimir</v-btn
        >
      </v-card-actions>
    </v-card>

    <template v-if="$store.state.debugModeOn">
      <v-divider></v-divider>
      <v-card>
        <v-card-text>
          <v-data-table :items="listTextoReciboDebug" :loading="loading" dense>
            <template v-slot:item="{ item }">
              <tr>
                <td class="text-xs-left caption">{{ item }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </template>

    <app-loading :loading="loading"></app-loading>

    <template v-if="$store.state.debugModeOn">
      Debug Info:
      <p></p>

      Model: {{ listComprobantes }}
      <p></p>
    </template>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { http } from '@/axios';
import axios from 'axios';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  data: () => ({
    loading: false,
    localConfig: {},
    apiSerialPrintValidada: false,
    comentarios: '',
    listComprobantes: [],
    listTextoReciboDebug: [],
    headers: [
      // definición de columnas
      { text: 'Tipo', value: 'tipo' },
      { text: 'Info', value: 'info' },
      { text: 'Importe', value: 'importe' },
    ],
    pagination: {
      // definición de paginación
      sortDesc: [true],
      sortBy: [''],
      page: 1,
      itemsPerPage: 10,
    },
    totalItems: 0, // va afuera de pagination
  }),
  props: {
    caja: { type: Object, default: {} },
    transaccionId: { type: String },
    accionCompleta: { type: Function },
    isSubTask: { type: Boolean, default: false },
    visible: { type: Boolean, default: false },
  },
  async created() {
    await this.loadLocalConfig();
    await this.loadComprobantesAImprimir();
  },
  computed: {
    ...mapGetters(['getActionFromLink', 'user', 'DebugModeOn']),
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
    apiSerialPrintConfigurada: function () {
      return (
        this.localConfig &&
        this.localConfig.usarTickeadora &&
        this.localConfig.apiSerialPrint != '' &&
        this.localConfig.port != ''
      );
    },
  },
  watch: {
    visible: function () {
      if (this.visible) {
      }
    },
  },
  methods: {
    ...mapMutations([
      'setActiveTask',
      'setActiveSubTask',
      'hideActiveTask',
      'hideActiveSubTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    async loadComprobantesAImprimir() {
      this.loading = true;

      var self = this;

      try {
        await http
          .get(
            'comprobantes/listparaimprimirportransaccionid?transaccionId=' +
              this.transaccionId
          )
          .then((res) => {
            // console.log(res.list);
            self.listComprobantes = res.list;
            self.totalItems = self.listComprobantes.length;
          });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async imprimir() {
      var self = this;

      self.loading = true;
      self.listTextoReciboDebug = [];

      // me quedo con los comprobantes que son distintos (porque los recibos/facturas los muestra por credito, pero son el mismo)
      var distinctComprobantes = Array.from(
        new Set(self.listComprobantes.map((x) => x.id))
      ).map((id) => {
        return {
          id: id,
          tipo: self.listComprobantes.find((i) => i.id === id).tipo,
        };
      });

      // proceso cada comprobante
      for (let i = 0; i < distinctComprobantes.length; i++) {
        const comprobante = distinctComprobantes[i];

        if (comprobante.tipo == 'Pago') {
          if (self.localConfig.usarTickeadora) {
            if (self.apiSerialPrintValidada) {
              await self.imprimirTicketRecibo(comprobante);
              const res = await this.$dialog.confirm({
                text: 'Corte el ticket y presione OK para Continuar',
                title: 'Atención',
                persistent: true, // Parece que no funciona...
              });
              if (res) await self.imprimirTicketRecibo(comprobante);
            } else {
              self.alertError(
                'Se configuró la impresión por tickeadora, pero no se pudo validar la Api de Impresión. Consulte con Sistemas.'
              );
            }
          }
        }
      }

      self.loading = false;
    },
    async imprimirTicketRecibo(comprobante) {
      var self = this;

      // busco el texto a imprimir
      await http
        .get('comprobantes/gettextoticketpago?id=' + comprobante.id)
        .then(async (res) => {
          Vue.$log.debug(res);
          self.listTextoReciboDebug.push(res);
          await self.imprimirTicket(res);
        })
        .catch(function (error) {
          self.alertError(error);
        });
    },
    async imprimirTicket(texto) {
      var self = this;

      const instance = axios.create({
        baseURL: this.localConfig.apiSerialPrint,
        timeout: 1000,
        headers: { 'X-Custom-Header': 'foobar' },
      });

      instance
        .post('/serialprint', {
          sendTo: this.localConfig.port,
          text: texto,
        })
        .then(function (response) {
          if (response.data != 'OK') {
            self.alertError(response.data);
            //Vue.$log.debug(response);
          }
        })
        .catch(function (error) {
          self.alertError(error);
        });
    },
    async loadLocalConfig() {
      var config = localStorage.getItem('localconfig');
      if (config != null) {
        this.localConfig = JSON.parse(config);

        if (this.localConfig.cajaId != 0) this.cajaId = this.localConfig.cajaId;

        if (this.apiSerialPrintConfigurada) {
          this.validarApiSerialPrint();
        }
      }
    },
    async validarApiSerialPrint() {
      var self = this;

      const instance = axios.create({
        baseURL: this.localConfig.apiSerialPrint,
        timeout: 1000,
        headers: { 'X-Custom-Header': 'foobar' },
      });

      instance
        .get('/itsalive')
        .then(function (response) {
          self.apiSerialPrintValidada = true;
        })
        .catch(function (error) {
          self.apiSerialPrintValidada = false;
          self.alertError('Error al validar la Api de Impresión: ' + error);

          Vue.$log.error(error);
        });
    },
    hide(cerrarRelacionados) {
      //esto lo hago para que no se buguee cuando lo abro como subtask o task
      if (this.isSubTask) this.hideActiveSubTask();
      else this.hideActiveTask(cerrarRelacionados);
    },
    emitAccionCompleta() {
      if (this.accionCompleta) this.accionCompleta();

      this.$emit('accion-completa');
    },
  },
};
</script>
